import { isOtherDocumentType } from '@prospero/shared';
import type { SameTypeSummaryRequest } from '../../hooks/deadline/use-same-type-summary';
import type { DocumentTypeItem } from '../../services/document-type/document-type.service';

const NO_REQUEST: SameTypeSummaryRequest = { documentTypeId: null };

/**
 * What the same type notice asks for. Nothing for "Altro" (unrelated free-named documents) and,
 * for a personal type (certificates, training), nothing until one person of one client is chosen:
 * the count is that person's.
 */
export function resolveSameTypeRequest(input: {
  documentType: DocumentTypeItem | null;
  assigneeUserId: string | null | undefined;
  clientCount: number;
}): SameTypeSummaryRequest {
  const { documentType, assigneeUserId, clientCount } = input;
  if (!documentType || isOtherDocumentType(documentType)) {
    return NO_REQUEST;
  }
  if (!documentType.isPersonal) {
    return { documentTypeId: documentType.id };
  }
  return assigneeUserId && clientCount === 1
    ? { documentTypeId: documentType.id, assigneeUserId }
    : NO_REQUEST;
}
